import { InfoCircleTwoTone } from '@ant-design/icons';
import { Button, Col, Modal, Row } from 'antd';
import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  DRAFT_CHANGE_STATUSES,
  ROUTE_CHANGE_CONFIRMATION_MESSAGE,
} from '../../constants/commonConstants';
import { RootState } from '../../../store';
import { updateSaveDraftStatus } from '../../../store/actions/savedDraftAction';
import { ERROR } from '../../constants/crmConstants';
import { mapClaimPdfData } from '../../../utils/utility';
import { downloadClaimPDF } from '../../../store/actions/newAdmissionAction';
import { NewAdmissionState } from '../../../store/models/newAdmissionModel';
import ApplicationDetail from '../../services/applicationDetail.service';
import { customGTMEvent } from '../../../modules/crm/inPatient/service/crmUtils';
interface IRouteGuardModal {
  visible: boolean;
  setVisible: any;
  message: string;
  setMessage: any;
  confirmationCallback: any;
}

const RouteGuardModal = (props: IRouteGuardModal): ReactElement => {
  const { visible, setVisible, message, setMessage, confirmationCallback } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const locationArray = history.location.pathname.split('/');
  const { draftCurrentStatus, draftErrorMessage } = useSelector((state: RootState): any => state.savedDraft);
  const { DRAFT_INITILIZING, DRAFT_SAVED } = DRAFT_CHANGE_STATUSES;
  const { admissionFormVal, admissionFormType, hospitalOtherRoomType } =
    useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const {
    payerLookUp,
    lookUp,
    payerList: { payer, payer: selectedPayer },
  } = useSelector((state: RootState): RootState => state);
  const { uniqueIdentifier } = selectedPayer || {};

  const appService = ApplicationDetail.instance;
  const hospitalDetails = appService.getHospitalDetail();
  const userDetails = appService.getUserDetail();

  const onDownloadPDFClickHandler = (formType: string): void => {
    let insurerName = '';
    if (formType === 'cashlessForm') {
      payerLookUp[uniqueIdentifier]?.insurerName.map((insurer: any): void => {
        if ( insurer.masterLookId === Number(admissionFormVal?.customerDetail?.insurerName) ) {
          insurerName = insurer.name;
        }
      });
    }
    const payload =
      mapClaimPdfData(
        formType, hospitalDetails, admissionFormVal,
        userDetails, insurerName, hospitalOtherRoomType, payer, admissionFormType, lookUp, payerLookUp,
      );

    dispatch(downloadClaimPDF(payload));
  };

  const getModalBasedOnRoute = (): any => {
    if (['new-admission', 'edit', 'discharge'].includes(locationArray[locationArray.length - 1].toLowerCase())
      && draftCurrentStatus !== ERROR) {
      customGTMEvent({
        event: 'Alert message when clicked on back',
      });
      return (
        <Modal
          visible={visible}
          onCancel={handleCancel}
          className="warning-model"
          footer={
            <>
              <Row className="mb-md text-left">
                <Col md={24}>
                  <p className="f_16 f_b">{ROUTE_CHANGE_CONFIRMATION_MESSAGE}</p>
                  <p>If no please select some action from below.</p>
                </Col>
                <Col
                  className="c-b-link"
                  onClick={(): void => onDownloadPDFClickHandler('cashlessForm')}
                >
                  <p>Download Cashless Form</p>
                </Col>
                <Col
                  className="c-b-link"
                  onClick={(): void => onDownloadPDFClickHandler('checklistForm')}
                >
                  <p>Download Checklist Form</p>
                </Col>
                <Col
                  className="c-b-link"
                  onClick={(): void => onDownloadPDFClickHandler('acknowledgementLetter')}
                >
                  <p>Download Acknowledgement Letter</p>
                </Col>
              </Row>
              <Row>
                <Col span={4}>
                  <Button
                    key="draft"
                    data-testid="save-draft-modal"
                    onClick={saveToDraft}
                    type="primary"
                  >
                    Save to draft
                  </Button>
                </Col>
                <Col span={4} offset={13}>
                  <Button
                    key="cancel"
                    data-testid="click-on-cancel"
                    onClick={handleCancel}
                    danger={true}
                  >
                    Cancel
                  </Button>
                </Col>&nbsp;
                <Col span={2}>
                  <Button
                    key="ok"
                    data-testid="click-on-ok"
                    onClick={handleOk}
                    type="primary"
                  >
                    Ok
                  </Button>
                </Col>
              </Row>
            </>
          }
        >
          <InfoCircleTwoTone className="fsize_lg" />&nbsp;
          <b className="f_16 f_b">{message}</b>
        </Modal>
      );
    } else if (draftCurrentStatus === ERROR) {
      return (
        <Modal
          visible={visible}
          onCancel={handleCancel}
          footer={
            <Row justify="end">
              <Col><Button key="ok" type="primary" onClick={handleOk}>Ok</Button></Col>
            </Row>
          }
        >
          <InfoCircleTwoTone className="fsize_lg" />&nbsp;
          {message}
        </Modal>
      );
    } else {
      return (
        <Modal
          visible={visible}
          onCancel={handleCancel}
          footer={
            <Row justify="end">
              <Col><Button key="cancel" data-testid="click-on-cancel" onClick={handleCancel}>Cancel</Button></Col>&nbsp;
              <Col><Button key="ok" type="primary" onClick={handleOk}>Ok</Button></Col>
            </Row>
          }
        >
          <InfoCircleTwoTone className="fsize_lg" />&nbsp;
          {message}
        </Modal>
      );
    }
  };

  const saveToDraft = (): void => {
    dispatch(updateSaveDraftStatus(DRAFT_INITILIZING));
  };

  useEffect((): any => {
    if (draftCurrentStatus === DRAFT_SAVED) {
      setVisible(false);
      confirmationCallback(true);
    } else if ( draftCurrentStatus === ERROR ) {
      setMessage(draftErrorMessage);
    }
  }, [draftCurrentStatus]);

  const handleCancel = (): any => {
    confirmationCallback(false);
    setVisible(false);
  };

  const handleOk = (): any => {
    confirmationCallback(true);
    setVisible(false);
  };

  return (
    <React.Fragment>
      {getModalBasedOnRoute()}
    </React.Fragment>
  );
};

export default RouteGuardModal;
